/* eslint-disable no-undef */
/* eslint-disable no-new */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';

const renderBanners = (banners = [], typeBanner, heightAuto) => (
  banners.map(banner => (((isMobile && banner.displayOn === 'webMobile') || (!isMobile && banner.displayOn === 'web'))
  && (banner.typeBanner === typeBanner) && (
    <div className="swiper-slide" key={banner.id} style={(heightAuto) ? { height: 'auto' } : {}}>
      {banner.redirectUrl ? (
        <a href={banner.redirectUrl}>
          <img id="bannerImage" src={banner.imageUrl} alt={banner.name} />
        </a>
      ) : (
        <a>
          <img id="bannerImage" src={banner.imageUrl} alt={banner.name} />
        </a>
      )}
    </div>
  )))
);

const Banner = (props) => {
  const {
    style = {}, classContainer = '', banners, typeBanner,
  } = props;

  useEffect(() => {
    new Swiper('.swiper-container', {
      slidesPerView: 1,
      slidesPerGroup: 1,
      pagination: {
        el: '.swiper-banner-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-banner-button-next',
        prevEl: '.swiper-banner-button-prev',
      },
      loop: !0,
      speed: 700,
      autoplay: { delay: 1e4 },
    });
  }, []);

  return (
    <div className="swiper-slide" style={{ ...style }}>
      <div className={`swiper-banner swiper-container ${classContainer}`}>
        <div className="swiper-wrapper">
          {renderBanners(banners, typeBanner, !!classContainer)}
        </div>
      </div>
    </div>
  );
};

export default Banner;
